/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_TitleInputs */



/**
* | output |
* | --- |
* | "Sanctions" |
*
* @param {Sanction_Mgr_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_title = /** @type {((inputs?: Sanction_Mgr_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sanctions")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sanciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sanções")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sanzioni")
	return /** @type {LocalizedString} */ ("Sanctions")
});